var pushStateUrls = window.EDMDataStorage.pushStateUrls;
var isPopstate = false;
var subNavLinkMapping = {};

function onPopstate(event) {
    isPopstate = true;
    if(event.state && event.state.scrollTop) {
        $(window).scrollTop(event.state.scrollTop);
    }
}

function urlQueryParams() {
    var retLocationSearch = [];
    var locSearchList = window.location.search.replace('?', '').split('&');
    locSearchList.forEach(function(val) {
        if(val.indexOf('tab-id') < 0) {
            retLocationSearch.push(val);
        }
    });
    return '?' + retLocationSearch.join('&');
}

function isValid(data) {
    return !pushStateUrls || !(data && data.relatedTarget);
}

/**
 * Should initialize this code after document loads.
 */
$(document).ready(function() {
    var url = window.location.pathname;
    if(window.location.search) {
        url += window.location.search;
    }
    url += window.location.hash;
    window.history.replaceState({ scrollTop: 0 }, null, url);
    history.scrollRestoration = 'manual';

    var subavLinks = $('.nav-link[data-external-link="true"]');
    subavLinks.each(function (i, subnavLink) {
        var $subnavLink = $(subnavLink);
        subNavLinkMapping[$subnavLink.attr('href')] = $subnavLink.data('original-link');
    });
});

function mapUrl(pushStateUrl) {
    if (subNavLinkMapping.hasOwnProperty(pushStateUrl)) {
        return subNavLinkMapping[pushStateUrl];
    } else {
        return pushStateUrl;
    }
}

$(window).on('activate.bs.scrollspy', function (ev, data) {
    if(isValid(data)) {
        return false;
    }
    var creativeId = data.relatedTarget.replace('#', '');
    var pushStateUrl = pushStateUrls[creativeId].href;
    pushStateUrl = mapUrl(pushStateUrl);
    var pushStateUrlHash = pushStateUrls[creativeId].hash;
    if(window.location.search) {
        pushStateUrl += urlQueryParams();
    }
    if(pushStateUrlHash) {
        pushStateUrl += pushStateUrlHash;
    }
    var currentState = {
        'creativeId': creativeId,
        'scrollTop': $(data.relatedTarget).offset().top
    };
    if(!isPopstate) {
        window.history.replaceState(currentState, null, pushStateUrl);
        window.history.pushState(currentState, null, pushStateUrl);
    }
    isPopstate = false;
});

window.addEventListener('popstate', onPopstate, false);


//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/engagement-handler/url-push-state-engagement-handler/url-push-state-engagement-handler.js
// module id = 97
// module chunks = 0 1 3 6 8 11 12 14